import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import React from 'react';
import { Box, Button, Container } from '@/DesignSystem/Component';
import type { IBoxPropsType, IButtonColorType } from '@/DesignSystem/Model/DataModel';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import type { ITeacherHome } from '@/Module/HomePage/Model/DataModel';
const NAME_COLORS: Record<number, string> = {
  1: 'text-orangeFive drop-shadow-lightOrange',
  2: 'text-blueFive drop-shadow-lightBlue ',
  3: 'text-greenFive drop-shadow-lightGreen',
  4: 'text-pinkFive drop-shadow-lightPink'
};
const BEFORE_COLORS: Record<number, string> = {
  1: 'bg-orangeFive',
  2: 'bg-blueFive ',
  3: 'bg-greenFive',
  4: 'bg-pinkFive'
};
const DESCRIPTION_COLORS: Record<number, string> = {
  1: 'text-orangeFive',
  2: 'text-blueFive ',
  3: 'text-greenFive',
  4: 'text-pinkFive'
};
const IMG_COLORS: Record<number, string> = {
  1: 'bg-orangeTwo border-2 border-orangeFive shadow-orangeFour',
  2: 'bg-blueTwo border-2 border-blueFive shadow-blueFive',
  3: 'bg-greenTwo border-2 border-greenFive shadow-greenFour',
  4: 'bg-pinkTwo border-2 border-pinkFour shadow-pinkFour'
};
const BOX_COLORS: Record<number, IBoxPropsType> = {
  1: 'orangeDark',
  2: 'secondary',
  3: 'green',
  4: 'pinkLight'
};
interface IHomeNewTeacher {
  data: ITeacherHome[];
}
const HomeNewTeacher: FC<IHomeNewTeacher> = ({
  data
}) => {
  return <Container className="max-w-[1300px]" data-sentry-element="Container" data-sentry-component="HomeNewTeacher" data-sentry-source-file="HomeNewTeacher.tsx">
      <div className="py-4 sm:py-12">
        <h2 className="mt-4 text-center text-4xl font-extrabold text-blueFive drop-shadow-lightBlue sm:mb-12 ">
          معلم‌های خفن آی‌نو
        </h2>
        <div className="flex flex-row flex-nowrap items-end gap-4 overflow-x-scroll pt-6 sm:grid sm:grid-cols-2 md:justify-center md:gap-4 md:overflow-x-hidden lg:grid-cols-4">
          {data.map(teacher => <Box key={teacher.img} as={Link} href={teacher.url} color={BOX_COLORS[teacher.id]} className={cs('cursor-pointer  pt-12 block px-5 min-w-[300px] sm:min-w-full max-w-[300px] mb-6  ')}>
              <div className={cs('cursor-pointer rounded-md max-w-[130px] mx-auto block shadow-middle ', IMG_COLORS[teacher.id])}>
                <Image width={126} height={174} src={`${FILE_BROWSER_URL}/img/teacher/${teacher.img}.webp`} key={teacher.img} alt={teacher.img} className="mr-[6pt] mt-[-40px] h-[152px] w-[110px]" />
              </div>
              <div className={cs('text-xl  flex font-extrabold mb-2 cursor-pointer mt-4 w-full justify-center', NAME_COLORS[teacher.id])}>
                {teacher.name}
              </div>
              <span className={cs('text-sm flex w-full justify-center mx-auto mb-2 cursor-pointer font-bold', NAME_COLORS[teacher.id])}>
                {teacher.grade}
              </span>
              <ul className="mb-6 flex-1 sm:mb-0">
                {teacher.description.split('\n').map(item => <li className="mb-3 flex flex-row   " key={item}>
                    <span className={cs(`bg-blueFive w-[6px] h-[6px] rounded-full mt-2`, BEFORE_COLORS[teacher.id])} />
                    <span className={cs(`text-blueFive mr-2 w-fit`, DESCRIPTION_COLORS[teacher.id])}>{item}</span>
                  </li>)}
              </ul>
              <div className="mb-6 flex w-full flex-col items-center justify-center">
                <Button color={teacher.color as IButtonColorType} radius="circle" variant="shadow" className="">
                  مشاهده پروفایل
                </Button>
              </div>
            </Box>)}
        </div>
        <div className="mb-6 mt-4 flex w-full flex-col items-center justify-center sm:mt-10">
          <Button color="blueN" as="a" href={LINKS.TEACHER_LIST} radius="circle" variant="shadow" className="font-bold " data-sentry-element="Button" data-sentry-source-file="HomeNewTeacher.tsx">
            دیدن همۀ معلم‌های آی‌نو
          </Button>
        </div>
      </div>
    </Container>;
};
export default HomeNewTeacher;